import { useState } from 'react';
import { toast } from 'sonner';
import { Field, inputCls, ListingToggle } from './_shared';

const EMPTY_PRODUCT = {
  name: '',
  brand: '',
  category: 'Apparel',
  description: '',
  base_price: '',
  discounted_price: '',
  images: [''],
  variants: [{ id: '', size: '', color: '', stock: 10 }],
  is_active: true,
};

export default function ProductForm({ initial, onSave, onCancel }) {
  const [form, setForm] = useState(
    initial ? { ...initial, is_active: initial.is_active ?? true } : EMPTY_PRODUCT
  );
  const [loading, setLoading] = useState(false);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));

  const handleVariant = (i, key, val) => {
    const v = [...form.variants];
    v[i] = { ...v[i], [key]: key === 'stock' ? Number(val) : val };
    setForm(f => ({ ...f, variants: v }));
  };
  const addVariant = () => setForm(f => ({ ...f, variants: [...f.variants, { id: '', size: '', color: '', stock: 10 }] }));
  const removeVariant = i => setForm(f => ({ ...f, variants: f.variants.filter((_, idx) => idx !== i) }));

  const save = async () => {
    if (!form.name || !form.brand || !form.base_price) { toast.error('Fill required fields'); return; }
    setLoading(true);
    try {
      const payload = {
        ...form,
        base_price: Number(form.base_price),
        discounted_price: form.discounted_price ? Number(form.discounted_price) : null,
        images: form.images.filter(Boolean),
      };
      await onSave(payload);
    } finally { setLoading(false); }
  };

  return (
    <div className="space-y-4 overflow-y-auto max-h-[75vh] pr-1">
      <ListingToggle
        checked={form.is_active}
        onChange={v => setForm(f => ({ ...f, is_active: v }))}
        noun="product"
      />
      <Field label="Product Name" required><input className={inputCls} value={form.name} onChange={set('name')} /></Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Brand" required><input className={inputCls} value={form.brand} onChange={set('brand')} /></Field>
        <Field label="Category">
          <select className={inputCls} value={form.category} onChange={set('category')}>
            {['Apparel', 'Footwear', 'Equipment', 'Accessories', 'Nutrition'].map(c => <option key={c}>{c}</option>)}
          </select>
        </Field>
      </div>
      <Field label="Description"><textarea className={inputCls} rows={3} value={form.description} onChange={set('description')} /></Field>
      <div className="grid grid-cols-2 gap-3">
        <Field label="Base Price (₹)" required><input type="number" className={inputCls} value={form.base_price} onChange={set('base_price')} /></Field>
        <Field label="Discounted Price (₹)"><input type="number" className={inputCls} value={form.discounted_price} onChange={set('discounted_price')} placeholder="Optional" /></Field>
      </div>
      <Field label="Image URL">
        <input className={inputCls} value={form.images[0] || ''} onChange={e => setForm(f => ({ ...f, images: [e.target.value] }))} placeholder="https://…" />
      </Field>
      <div className="bg-gray-50 rounded-xl p-4 space-y-3">
        <div className="flex items-center justify-between">
          <p className="text-xs font-bold text-gray-500 uppercase tracking-wide">Variants</p>
          <button onClick={addVariant} className="text-xs font-bold text-[#2B3A67]">+ Add</button>
        </div>
        {form.variants.map((v, i) => (
          <div key={i} className="grid grid-cols-3 gap-2 bg-white rounded-xl p-3 border border-gray-100">
            <Field label="Size"><input className={inputCls} value={v.size} onChange={e => handleVariant(i, 'size', e.target.value)} placeholder="M / L…" /></Field>
            <Field label="Color"><input className={inputCls} value={v.color} onChange={e => handleVariant(i, 'color', e.target.value)} placeholder="Red…" /></Field>
            <Field label="Stock"><input type="number" className={inputCls} value={v.stock} onChange={e => handleVariant(i, 'stock', e.target.value)} /></Field>
            {form.variants.length > 1 && <button onClick={() => removeVariant(i)} className="col-span-3 text-xs text-red-400 text-left">Remove variant</button>}
          </div>
        ))}
      </div>
      <div className="flex gap-3">
        <button onClick={onCancel} className="flex-1 py-3 rounded-2xl border-2 border-gray-200 font-bold text-sm">Cancel</button>
        <button onClick={save} disabled={loading} className="flex-1 py-3 rounded-2xl bg-[#2B3A67] text-white font-extrabold text-sm disabled:opacity-60">
          {loading ? 'Saving…' : 'Save Product'}
        </button>
      </div>
    </div>
  );
}
